<template>
  <admin-layout title="Salas de reuniões ao vivo" menu="Live">
    <title>Live</title>
    <div class="row mb-3">
      <div class="col-lg-12 col-xs-12 pr-2">
        <div>
          <div class="row">
            <div class="col-lg-2 col-xs-12">
              <div class="form-group color-dark-purple mb-0">
                <h3>SALAS</h3>
              </div>
            </div>
            <div class="col-lg-3 col-xs-10 p-0 m-0">
              <inertia-link href="/recruiters/rooms/new">
                <button class="btn-new-job" style="height: 38px; width: 93%">
                  CRIAR SALA
                </button>
              </inertia-link>
            </div>
            <div class="col-lg-7"></div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-9 col-xs-12"></div>

            <div class="col-lg-3 col-xs-12">
              <div
                class="form-group mb-0 has-search d-flex justify-content-end"
                style="margin-left: -3px"
              >
                <div>
                  <span
                    class="fa fa-search ml-2 mt-2 pr-2 mr-3 form-control-feedback"
                  ></span>
                </div>
                <input
                  type="text"
                  v-model="search"
                  v-on:keyup.enter="searchRooms"
                  class="form-control no_border"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-lg-4 mb-3 col-xs-12">
        <div class="input-group md-form form-sm form-2 pl-0">
          <input
            class="form-control my-0 py-1 red-border"
            type="text"
            placeholder="Pesquisar"
            aria-label="Search"
            v-model="search"
            v-on:keyup.enter="searchRooms"
          />
          <div class="input-group-append">
            <span class="input-group-text red lighten-3" id="basic-text1">
              <i class="fas fa-search text-grey" aria-hidden="true"></i>
            </span>
          </div>
        </div>
      </div>-->
      <!-- <div class="col-lg-8 col-xs-12">
        <inertia-link :href="`/recruiters/rooms/new`">
          <button class="btn btn-primary right">
            Criar sala
            <i class="fas fa-plus" />
          </button>
        </inertia-link>
      </div>-->
      <div class="col-lg-12 col-xs-12 mt-3">
        <table class="table_jovool">
          <thead class="headerTable">
            <tr>
              <td>
                TÍTULO
                <OrderTable field="title" entity="room" />
              </td>
              <td>
                DATA INÍCIO
                <OrderTable field="start_date" entity="room" pre_order="desc" />
              </td>
              <td>
                DATA TÉRMINO
                <OrderTable field="end_date" entity="room" />
              </td>
              <td>LINK</td>
              <td>EDITAR</td>
            </tr>
          </thead>
          <tbody class="position-relative">
            <tr
              v-for="room in rooms"
              :key="room.id"
              :class="{ 'content-loading': loading }"
            >
              <td>{{ room.title }}</td>

              <td>{{ formattedDate(room.start_date) }}</td>
              <td>{{ formattedDate(room.end_date) }}</td>
              <td>
                <!-- <button
                  v-clipboard:copy="room.link"
                  v-clipboard:success="onCopy"
                  type="button"
                  class="btn btn-primary"
                >-->
                <span
                  v-clipboard:copy="room.link"
                  v-clipboard:success="onCopy"
                  class="pointer color-grey"
                  title="Copiar URL"
                >
                  <font-awesome-icon icon="link" />
                </span>
                <!-- </button> -->
              </td>
              <td>
                <inertia-link :href="`/recruiters/rooms/${room.id}/edit`">
                  <!-- <button type="button" class="btn btn-success"> -->
                  <span class="pointer color-grey" title="Editar live">
                    <i class="fa fa-pencil-alt"></i>
                  </span>
                  <!-- </button> -->
                </inertia-link>
              </td>
            </tr>
            <div
              class="center position-absolute loading-gif"
              :class="{ 'd-none': !loading || firstLoad }"
            >
              <img src="/images/loading.gif" alt="loading-gif" />
            </div>
          </tbody>
        </table>
        <v-pagination
          v-model="currentPage"
          :page-count="pageCount"
          class="justify-content-center"
          :class="firstLoad ? 'd-none' : 'd-flex'"
          :classes="bootstrapPaginationClasses"
        ></v-pagination>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import moment from "moment";
import OrderTable from "components/OrderTable.vue";
import vPagination from "vue-plain-pagination";
export default {
  components: {
    OrderTable,
    vPagination,
  },
  mounted() {
    moment.locale("pt-br");
    this.searchRooms();
    eventBus.$on("orderColumnroom", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchRooms();
    });
  },
  data: () => ({
    rooms: [],
    field: "",
    order: "",
    search: "",
    firstLoad: true,
    loading: false,
    totalRooms: 0,
    currentPage: 1,
    pageCount: 1,
    bootstrapPaginationClasses: {
      ul: "pagination",
      li: "page-item",
      liActive: "active",
      liDisable: "disabled",
      button: "page-link",
    },
  }),
  watch: {
    currentPage: function () {
      this.searchRooms();
    },
  },
  methods: {
    onCopy: function (e) {
      this.$toast.success("LINK COPIADO COM SUCESSO");
    },
    searchRooms() {
      let params = {};

      params["order"] = { start_date: "desc" };
      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      }
      params["search"] = this.search;
      if (this.search == "") {
        params["search"] = "*";
      }

      this.loading = true;
      axios
        .get(`/recruiters/rooms/search/${this.currentPage}`, {
          params: params,
        })
        .then((response) => {
          console.log(response.data.rooms);
          this.rooms = response.data.rooms;
          this.totalRooms = response.data.total_rooms;
          this.pageCount = Math.ceil(this.totalRooms / 10);
          this.firstLoad = false;
          this.loading = false;
        });
    },
    formattedDate(date) {
      return moment(date, "YYYY-MM-DD h:mm").format("DD/MM/YYYY LT") + "h";
    },
  },
};
</script>
